import { createContext, useContext } from 'react'
import { type Otp } from '../types/dataModel/platformSdk'

export interface CosignContextProps {
  lineLogin?: boolean
  facebookLogin?: boolean
  googleLogin?: boolean
  emailLogin?: boolean
  lineSubscribe?: boolean
  customLogo?: 'STM'
  projectCode: 'HM' | 'DCS' | 'LM' | 'MNP' | 'AQUA' | 'PP' | 'PM' | 'YT' | 'RS'
  privacypoliciesLink?: string
  intellectualLink?: string
  serverLink?: string
  title: 'Buygather' | 'DogCatStar' | '怪獸部落' | 'HeroMaMa' | 'Lady N' | '角落水族' | '日日貓砂' | '毛掌醫學' | '虎留香' | '日幸' | ''
  routeMap?: Partial<{
    campaign: string
    merchant: string
    login: string
    passwordRegister: string
    passwordChange: string
    passwordReset: string
    passwordSuccess: string
    bindPhone: string
    editAccount: string
  }>
  environment?: 'wordPress' | 'merchant' | 'campaign'
  campaignCode?: string
  redirectUrl?: Otp['redirectUrl']
  fallbackUrl?: Otp['fallbackUrl']
  tokenLoginUrl?: Otp['tokenLoginUrl']
  /** 啟用登入後邀請 LINE  */
  lineInvitation?: boolean
}

export const CosignContext = createContext<CosignContextProps>({
  emailLogin: false,
  lineLogin: false,
  facebookLogin: false,
  googleLogin: false,
  lineSubscribe: false,
  projectCode: 'DCS',
  privacypoliciesLink: '',
  intellectualLink: '',
  serverLink: '',
  title: '',
  environment: 'wordPress',
  routeMap: {
    campaign: '/my-account',
    merchant: '/my-account',
    login: '/my-account',
    passwordRegister: '/password/register',
    passwordChange: '/password/change',
    passwordReset: '/password/reset',
    passwordSuccess: '/password/success',
    bindPhone: '/bind-phone',
    editAccount: '/my-account/edit-account',
  },
  redirectUrl: undefined,
  fallbackUrl: undefined,
  tokenLoginUrl: undefined,
  lineInvitation: undefined,
})

export function useContextCosign() {
  const cosignContext = useContext(CosignContext)

  if (!cosignContext) throw new Error('CosignContext has to be used within <CosignContext.Provider>')

  return cosignContext
}
